/**
 *  create by tnanc
 */
import types from '../mutation-types'
import commonService from '@/service/commonService'
const state = {
  userinfo: {}
}

const getters = {
  userinfo: state => state.userinfo
}

const actions = {
  async fetchUserInfo ({commit}) {
    let data = await commonService.fetchUserInfo()
    commit('setUserInfo', data)
    return data
  }
}

const mutations = {
  setUserInfo (state, data) {
    state.userinfo = data
  },
  clearUserInfo (state) {
    state.userinfo = {}
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/user.js